
export const Header = ({
    description = "Delivering value through AI and data solutions"
}) => (
    <header className="bg-gray-200 text-gray-800 p-4 relative text-center">
        <div className='cursor-pointer flex flex-col items-center justify-center' onClick={() => {
            window.location.href = "/"
        }}>
            {/* <h1 className="text-2xl font-bold"></h1> */}
            <img src="/images/logo_256.png" className="h-8" />
            <p className="text-md mt-2 capitalize font-bold">{description}</p>
        </div>
    </header>
);